import { IconCirclePlus, IconSearch } from "@tabler/icons-react";

const TabClientes = ({ clientes, onEditar, onEliminar, busqueda, setBusqueda, abrirModal }) => {
  return (
    <>
      <div className="btn-list mb-5">
        <div className="me-auto">
          <div className="input-icon">
            <input type="text" className="form-control" style={{ minWidth: "400px" }} placeholder="Buscar por nombre o código..." value={busqueda} onChange={(e) => setBusqueda(e.target.value)} autoFocus />
            <span className="input-icon-addon">
              <IconSearch className="icon icon-1" />
            </span>
          </div>
        </div>

        <button className="btn btn-primary btn-pill" onClick={abrirModal} title="Agregar un nuevo cliente">
          <IconCirclePlus className="icon icon-2" />
          Agregar Cliente
        </button>
      </div>

      <table className="table table-hover table-striped table-vcenter">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Código</th>
            <th>Estado</th>
            <th>Creado en</th>
            <th>Creado por</th>
          </tr>
        </thead>
        <tbody>
          {clientes.map((cliente) => (
            <tr key={cliente.id} onClick={() => onEditar?.(cliente)} style={{ cursor: "pointer" }}>
              <td>{cliente.nombre}</td>
              <td>{cliente.codigo}</td>
              <td>
                <span className="d-inline-flex align-items-center">
                  <span className={`badge me-1 ${cliente.estado === 1 ? "bg-success" : "bg-secondary"}`}></span>
                  {cliente.estado === 1 ? "Activo" : "Inactivo"}
                </span>
              </td>
              <td>{new Date(cliente.creado_en).toLocaleDateString("es-CL")}</td>
              <td>{cliente.username}</td>
            </tr>
          ))}

          {clientes.length === 0 && (
            <tr>
              <td colSpan="5" className="text-center text-muted">
                No se encontraron clientes.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
};

export default TabClientes;
